import { useMutation, useQueryClient } from "react-query";
import { addEmployeeAdOverrideGroup } from "../api";
import { toast } from "components/toastNotification";

const useAddEmployeeAdOverrideGroup = () => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation((data) => addEmployeeAdOverrideGroup(data), {
    onSuccess: (res) => {
      if (res?.data === "Duplicate") {
        toast.fire(
          "Failed",
          "Employee Ad Override Group is already exist.",
          "error"
        );
      } else {
        toast.fire(
          "Success",
          "Added Employee Ad Override Group Successfully",
          "success"
        );
      }
      queryClient.invalidateQueries();
    },
    onError: (error) => {
      toast.fire("Failed", "Failed to Add Employee Ad Override Group", "error");
    },
  });
  return mutate;
};

export default useAddEmployeeAdOverrideGroup;
